module.exports = __webpack_public_path__ + "static/media/SHSProdIcons__Chomecast.79d82cb9.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons__Chomecast.svg
// module id = 3434
// module chunks = 0